import Vue from "vue";
import App from "./App.vue";
import "./registerServiceWorker";
import router from "./router";
import store from "./store";
import vuetify from "./plugins/vuetify";
import firebase from "@firebase/app";
import VueAnalytics from "vue-analytics";

import InstantSearch from 'vue-instantsearch';

Vue.use(InstantSearch);

// Your web app's Firebase configuration
var firebaseConfig = {
  apiKey: "AIzaSyBIOV1SVzFwUbtym23pZOcBxgvhPfRTQXY",
  authDomain: "mental-challenge.firebaseapp.com",
  databaseURL: "https://mental-challenge.firebaseio.com",
  projectId: "mental-challenge",
  storageBucket: "mental-challenge.appspot.com",
  messagingSenderId: "779268867831",
  appId: "1:779268867831:web:514917945c35ea79e2f5f2",
  measurementId: "G-SMMPDKDHV2",
};
// Initialize Firebase
firebase.initializeApp(firebaseConfig);
// firebase.analytics();

// const isProd = process.env.NODE_ENV === 'production';

Vue.use(VueAnalytics, {
  id: 'UA-172928920-1',
  router,
  autoTracking: {
    exception: true,
  },
  // debug: {
  //   enabled: !isProd,
  //   sendHitTask: isProd,
  // },
});

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  vuetify,
  render: (h) => h(App),
}).$mount("#app");
